import { makeVar } from '@apollo/client'

import { AccountSelectItem } from 'components/AccountSelect'

export const rvForceMigrationPaymentInstrument = makeVar<
  AccountSelectItem | undefined
>(undefined)
